import { useLocation } from "react-router-dom";
import localeText from "../../../../locale";
import { PLATFORM_PRODUCT_FEE } from "../../../../utilities/constants";
import { formatPrice } from "../../../../utilities/formatPrice";

const PromotionalPrice = ({ productInfo, currency }) => {
  const { product, productVariations } = productInfo?.data;
  const { promotionalPriceUnique } = product;

  const hasNotPromotionalPrice = !promotionalPriceUnique && promotionalPriceUnique <= 0;
  const hasNotVariation = productVariations.length !== 0;

  if (hasNotPromotionalPrice || hasNotVariation) return null;

  const promotionalPrice = promotionalPriceUnique * PLATFORM_PRODUCT_FEE + promotionalPriceUnique;
  const price = product.priceUnique * PLATFORM_PRODUCT_FEE + product.priceUnique;
  const percentageDiscount = ((price - promotionalPrice) / price) * 100;
  return (
    <div className="flex align-items-center ">
      <span className="text-lg mr-2" style={{ color: "#FF607D" }}>
        -{percentageDiscount.toFixed(0)}%
      </span>
      <span
        className="flex align-items-center font-bold text-4xl title"
        style={{ color: "#091E42" }}
      >
        {currency} {formatPrice(promotionalPrice)}
      </span>
    </div>
  );
};

export default PromotionalPrice;
